import { Frequency } from '@emi/shared/models';
import { TimeSeriesColumnLabels } from './time-series-column-labels';
import { TimeSeriesSkuCollection } from './time-series-sku-collection';

export class TimeSeriesTableData {
  constructor(
    public startDate: Date,
    public endDate: Date,
    public frequency: Frequency,
    public timeSeriesColumnLabels: TimeSeriesColumnLabels[],
    public data: TimeSeriesSkuCollection[]
  ) { }
}
